/**
 * Shared admin gate for UI surfaces.
 *
 * Production desk admins should be provisioned with:
 *   setCustomUserClaims(uid, { qfaaOperator: true })
 * (see scripts/grant-qfaa-operator.mjs). The email/username allowlists are a
 * local/dev bootstrap so named desk accounts can open the admin shell before a
 * claim is minted.
 */
export const ADMIN_EMAIL_ALLOWLIST = Object.freeze([
  'chris@jtncgroup.com',
  'b@jtncgroup.com',
  'marcus@jtncgroup.com',
  'oscar@jtncgroup.com',
  'beam.qa@jtncgroup.com',
  'marcusm@limitlesstrading.academy',
]);

export const ADMIN_USERNAME_ALLOWLIST = Object.freeze([
  'marcus_limitless1',
]);

export const isAllowlistedAdminEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  return ADMIN_EMAIL_ALLOWLIST.includes(email.trim().toLowerCase());
};

export const isAllowlistedAdminUsername = (username) => {
  if (!username || typeof username !== 'string') return false;
  return ADMIN_USERNAME_ALLOWLIST.includes(username.trim().toLowerCase());
};

/**
 * @param {{ user?: { email?: string | null } | null, userProfile?: { email?: string, username?: string, role?: string, isAdmin?: boolean } | null, operatorClaim?: boolean | null }} args
 */
export const resolveIsAdmin = ({ user, userProfile, operatorClaim }) => {
  if (operatorClaim === true) return true;
  if (userProfile?.role === 'admin' || userProfile?.isAdmin === true) return true;
  const email = user?.email || userProfile?.email || '';
  if (isAllowlistedAdminEmail(email)) return true;
  return isAllowlistedAdminUsername(userProfile?.username || '');
};
